import React, { useState } from "react";
import "./VideoPopup.css";
import { useSelector } from "react-redux";
import { Alert } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { logout } from "../redux/slices/authSlice";
import API from "../constants/apiConfig";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const VideoPopup = ({ videos, currentVideoIndex, loadVideo, closePopup }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = useSelector((state) => state.auth.user?.id);
  const options = videos[currentVideoIndex]?.options || [];
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loadingButtonId, setLoadingButtonId] = useState(null);

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleOptionClick = async (item, index) => {
    setLoadingButtonId(index);
    const body = {
      user_id: userId,
      video_id: item.video_id,
      question_id: item.question_id,
      question_type: videos[currentVideoIndex].question_type,
      answer_option_id: item.answer_option_id,
      right_ans: item.answer,
      completed_video_id: videos[currentVideoIndex].video_id,
    };
    try {
      const response = await fetch(API.SUBMIT_OPTION, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          arkv: "!$Learn#$!",
        },
        body: JSON.stringify(body),
      });
      const result = await response.json();
      console.log("result", result);

      if (result.code === "200") {
        console.log("item.video_url", item.video_url);
        loadVideo(
          item.video_url,
          videos.findIndex((video) => video.video_url === item.video_url)
        );
      } else if (result.code === "100") {
        navigate("/login");
        handleLogout();
      } else {
        setError("Something went wrong");
        console.error("Failed to submit answer:", result);
      }
    } catch (error) {
      setError("Unexpected error occurred");
      console.error("Error while calling API:", error);
    } finally {
      setLoadingButtonId(null); // Reset the loading button index
    }
  };

  return (
    <div id="popup-container" className="show">
      <div id="popup-content">
        {videos?.[currentVideoIndex] ? (
          <>
            <div id="instruction-text" className="instruction-text">
              {videos[currentVideoIndex].question}
            </div>
            <div id="popup-grid">
              {options.map((item, index) => (
                <div className="popup-item" key={index}>
                  {item.image_url && (
                    <img
                      src={item.image_url}
                      className="popup-image"
                      alt={item.q_option}
                    />
                  )}
                  <button
                    className="popup-button"
                    onClick={() => handleOptionClick(item, index)}
                    disabled={loadingButtonId === index}
                  >
                    {loadingButtonId === index ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      item.q_option
                    )}
                  </button>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div style={{ color: "red", textAlign: "center" }}>
            Error: Video data is missing.
          </div>
        )}
        <div style={{ paddingTop: "30px" }}>
          {success ? (
            <Alert variant="success">"{success}"</Alert>
          ) : error ? (
            <Alert variant="danger">{error}</Alert>
          ) : null}
        </div>

        <button className="close-btn" onClick={closePopup}>
          Close
        </button>
      </div>
    </div>
  );
};

export default VideoPopup;
